export const SITE_URL = 'https://lorebites.com';

export const DEFAULT_TITLE = 'LoreBites';
export const DEFAULT_DESCRIPTION =
  'Classic and favorite books compressed into narrated rhymed Bites — holographic foil cards with word-level captions.';

export function absoluteUrl(path = '/') {
  if (!path || path === '/') return SITE_URL;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export function bookPageDescription(book) {
  if (!book) return DEFAULT_DESCRIPTION;
  const genres = Array.isArray(book.category) && book.category.length
    ? book.category.join(', ')
    : null;
  const base = `${book.title} by ${book.author} — compressed into narrated LoreBites.`;
  return genres ? `${base} ${genres}.` : base;
}
